const labels = {
  All: { 'See the offering': 'Zie het aanbod' },
  FacilityDetails: {
    'Ref: Page title': 'Details van de diensten',
    'Ref: Review': 'Opnieuw bekijken',
  },
  FacilitiesList: { 'Ref: Page title': 'Faciliteiten', 'Ref: See details': 'Zie de details' },
};
export default labels;
